import * as React from "react";

function SvgLinkedin(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.123 3H4.877C3.84 3 3 3.84 3 4.877v30.246C3 36.16 3.84 37 4.877 37h30.246C36.16 37 37 36.16 37 35.123V4.877C37 3.84 36.16 3 35.123 3zM13.54 31.286H8.77V15.83h4.77v15.456zM11.155 13.72a2.76 2.76 0 110-5.52 2.76 2.76 0 010 5.52zm20.075 17.566h-4.766v-7.52c0-1.793-.032-4.1-2.5-4.1-2.502 0-2.885 1.954-2.885 3.972v7.648h-4.764V15.83h4.573v2.113h.065c.637-1.206 2.192-2.478 4.512-2.478 4.826 0 5.715 3.177 5.715 7.308v8.513z"
        fill="#000"
      />
    </svg>
  );
}

export default SvgLinkedin;
